import {ENROLL_ADD_SECTION_PRE, ENROLL_REMOVE_SECTION_PRE, SELECT_ENROLL_SUBJECT_PRE} from '../actionTypes'


export default function (state = {subject: {}}, action) {
    //console.log(action.type);
    //console.log(action.payload);
    switch (action.type) {
        case SELECT_ENROLL_SUBJECT_PRE:
            return action.payload
        case ENROLL_ADD_SECTION_PRE:
            if (state.sections) {
                let sections = state.sections.filter(sec => {
                    return sec.sectionId != action.payload.sectionId
                })
                sections.push(action.payload)
                state.sections = sections
            } else {
                state.sections = [action.payload]
            }
            return state
        case ENROLL_REMOVE_SECTION_PRE:
            if (state.sections) {
                let sections = state.sections.filter(sec => {
                    return sec.sectionId != action.payload.sectionId
                })
                state.sections = sections
            }
            return state

    }

    return state;
}
